export default {
  light: 'sfufuturalight',
  bold: 'sfufuturabold',
  regular: 'sfufuturaregular',
  heading: 'sfufuturabold',
}
